<template>
    <div class="modal">
        <div class="model-body">
            <div class="title">请确认微信支付是否已完成</div>
            <div class="btns" @click="getPaySattus">支付完成</div>
            <div @click="closeMolel">支付遇到了问题，重新支付</div>
    </div>
    </div>
    
</template>
<script>
import http from '@/utils/http'
import apis from '@/utils/apis'
export default {
    data() {
        return {

        }
    },
    props: ['orderNo', 'isfrom'],
    methods: {
        async getPaySattus() {
            console.log('22222')
             let url='/renren-fast/app/h5pay/getOrderStatus'
            let params={ orderNo: this.orderNo }
            if(this.isfrom==='hotel') {
                url = '/renren-fast/app/hotel/getOrderStatus'
            }
            const res = await http.get( url, {params})
            if(res.code==0&&res.status=='SUCCESS'){
               console.log('支付成功！！')
                if  (this.isfrom==='hotel') {
                    this.$router.push('/pay_success')
                    return
                }
                // this.getAudienceMobile()
                this.$router.push('/pay_success?from=ticket')
            }else if(res.code==0&&res.status=='FAIL'){
                this.$emit('closeMolel')
               this.$alert('支付失败')
            }else if(res.code==500){
               this.$emit('closeMolel')
              this.$alert('支付失败')
            }
        },
        closeMolel() {
            this.$emit('closeMolel')
        }
    }
}
</script>
<style lang="stylus" scoped>
    .modal
        position fixed
        left 0
        right 0
        top 0
        bottom 0
        background rgba(0,0,0,0.4)
        display flex
        justify-content center
        align-items center
    .model-body
        width 600px
        padding 0 30px
        font-size 26px
        border-radius 10px
        text-align center
        background #fff
        .title
            font-size 28px
        div
            line-height 100px
        .btns
            border-top 1px solid #eee
            border-bottom 1px solid #eee
            color red
</style>

